
export default {

  props: ["element", "maxWidth","overrideClass"],
  name: "hyperCoreRow",
  data() {
    return {
      unselected: [],
    };
  },
  methods: {
    percentage(v) {
      if (v == "auto" || v == "" || !v) {
        return "auto";
      }
      return isNaN(v) ? v : v + "px";
    },
    isRelative(i) {
      let wm =
        this.$hyperLayout.selectProduct(i, this.element).style.widthMobile ||
        this.$hyperLayout.selectProduct(i, this.element).style.width ||
        "200px";
      return wm.includes("%") ? "56vw" : this.percentage(wm);
    },
    toggleSelection(i) {
      this.unselected.includes(i.barcode)
        ? this.unselected.splice(this.unselected.indexOf(i.barcode), 1)
        : this.unselected.push(i.barcode);
    },
  },
};
